import { tns } from 'tiny-slider/src/tiny-slider';

(function() {

  // Helper functions

  /**
   * Show an element
   * @param {HTMLElement} element
   */
  const showElement = (element, display = 'block') => {
    element.style.display = display;
  }

  /**
   * Hide an element
   * @param {HTMLElement} element
   */
  const hideElement = (element) => {
    element.style.display = 'none';
  }

  /**
   * Disable body scroll
   */
  const disableBodyScroll = () => {
    document.body.style.overflow = 'hidden';
  }

  /**
   * Enable body scroll
   */
  const enableBodyScroll = () => {
    document.body.style.overflow = 'auto';
  }
  
  const videoPlayers = {
    _playerElements: [],
    _players: {},
    init: function() {
      this._playerElements = Array.from(document.querySelectorAll('.essenza-yt-player'));
      this.maybeLoadYTApi();
    },
    initVideoPlayers: function() {

      // Bind the click event to the play buttons
      const playButtons = document.querySelectorAll('.essenza-product-slider-img--main button');
      playButtons.forEach(button => {
        button.addEventListener('click', this.onPlayButtonClick.bind(this));
      });

      // Initialize the players
      this._playerElements.forEach(element => {
        this.initPlayer(element);
      });
    },
    initPlayer: function(element) {
      const playerId = element.id;

      if ( !playerId ) {
        return;
      }

      const iframe = element.querySelector('iframe');

      if ( !iframe ) {
        return;
      }

      const player = new window.YT.Player(iframe);
      this._players[playerId] = player;

      // Bind close event
      const closeButton = element.querySelector('.essenza-yt-player__close');

      closeButton.addEventListener('click', this.onCloseButtonClick.bind(this, element));
      
    },
    onCloseButtonClick: function(element) {
      const playerId = element.id;
      this._players[playerId].stopVideo();

      // Hide the player
      hideElement(element);
    },
    onPlayButtonClick: function(event) {
      event.preventDefault();
      const target = event.currentTarget;
      const playerId = target.dataset.videoPlayerId;

      console.log(this._playerElements);

      // Show the player
      showElement(this._playerElements.find(element => element.id === playerId), 'flex');

      // Play the video
      this._players[playerId].playVideo();
    },
    maybeLoadYTApi: function() {
      if ( this._playerElements.length === 0 ) {
        return;
      }

      // If the YT API is already loaded, initialize the players directly.
      if (window.YT && window.YT.Player) {
        this.initVideoPlayers();
        return;
      }

      // If the script tag is already on the page, it might still be loading,
      // so we just need to make sure our callback is hooked.
      if (document.querySelector('script[src="https://www.youtube.com/iframe_api"]')) {
        window.onYouTubeIframeAPIReady = this.onYTApiLoaded.bind(this);
        return;
      }

      // Hook YT API callback
      window.onYouTubeIframeAPIReady = this.onYTApiLoaded.bind(this);

      const script = document.createElement('script');
      script.src = 'https://www.youtube.com/iframe_api';
      script.async = true;
      document.body.appendChild(script);
    },
    onYTApiLoaded: function() {
      this.initVideoPlayers();
    }
  }

  /**
   * Mega Menu
   * @type {Object}
   */
  const megaMenu = {
    _mobileMenu: {
      isOpen: false,
      elements: {
        nav: document.querySelector('.essenza-header__navigation'),
        burger: document.querySelector('.nav-burger'),
      },
      init: function() {
        this.elements.burger.addEventListener('click', this.toggle.bind(this));

        // Bind the click event to the parent items
        const parentItems = document.querySelectorAll('.essenza-mega-menu__item > a');
        parentItems.forEach(item => {
          item.addEventListener('click', this.onParentItemClick.bind(this));
        });

        // Bind the click event to the 'go back' titles
        const goBackTitles = document.querySelectorAll('.mega-menu-mobile__title');
        goBackTitles.forEach(item => {
          item.addEventListener('click', this.onGoBackClick.bind(this));
        });
      },
      toggle: function() {
        this.isOpen = !this.isOpen;
        this.elements.nav.classList.toggle('is-open', this.isOpen);
        this.elements.burger.classList.toggle('is-open', this.isOpen);
        
        if ( this.isOpen ) {
          disableBodyScroll();
        } else {
          enableBodyScroll();
        }
      },
      showMobileContentWrapper: function(id) {
        const mobileWrapper = document.querySelector('#mega-menu-mobile-content-' + id);
        mobileWrapper.classList.add('is-open');
      },
      hideMobileContentWrapper: function(id) {
        const mobileWrapper = document.querySelector('#mega-menu-mobile-content-' + id);
        mobileWrapper.classList.remove('is-open');
      },
      onParentItemClick: function(event) {
        // If Desktop, bail
        if ( window.innerWidth > 1024 ) {
          return;
        }

        const hasChildren = event.currentTarget.hasAttribute('data-has-children');

        if ( !hasChildren ) {
          return;
        }

        event.preventDefault();
        const target = event.currentTarget;
        const megaMenuId = target.dataset.mobileId;
        this.showMobileContentWrapper(megaMenuId);
      },
      onGoBackClick: function (event) {
        event.preventDefault();
        const target = event.currentTarget;
        const megaMenuId = target.dataset.mobileId;

        this.hideMobileContentWrapper(megaMenuId);
      },
    },
    _tree: [],
    _currentId: null,
    init: function() {
        this.buildTree();
        this.bindEvents();

        // Initialize the mobile menu
        this._mobileMenu.init();

        // Pick the first item for each mega menu
        this._tree.forEach(item => {
            const firstParentItem = item.parentItems[0];
            firstParentItem.element.classList.add('is-active');
            showElement(firstParentItem.childrenContainer);
        });
    },
    /**
     * Build the tree
     */
    buildTree: function() {
      const megaMenuContainers = document.querySelectorAll('.essenza-mega-menu__container');

      megaMenuContainers.forEach(container => {
        const parentItems = container.querySelectorAll('.essenza-mega-menu__children li:not(.essenza-mega-menu__children-actions)');

        let treeItem = {
          container,
          parentItems: []
        };

        parentItems.forEach(item => {
          const megaMenuId = item.dataset.megaMenuId;
          const megaMenuChildrenContainer = document.querySelector('#mega-menu-content-' + megaMenuId);

          treeItem.parentItems.push({
            id: megaMenuId,
            element: item,
            childrenContainer: megaMenuChildrenContainer
          });
        });

        this._tree.push(treeItem);
      });
      
    },
    /**
     * Bind events
     */
    bindEvents: function() {
      // Pluck the parent items from the tree
      let parentItems = this._tree.map(item => item.parentItems);

      // Flatten the array
      parentItems = parentItems.flat();

      parentItems.forEach(item => {
        item.element.addEventListener('mouseenter', this.onParentItemHover.bind(this));
      });
    },
    /**
     * On parent item hover
     * @param {Event} event
     */
    onParentItemHover: function(event) {
        const target = event.target;
        const megaMenuId = target.dataset.megaMenuId;

        const allParentItems = this._tree.map(item => item.parentItems);

        // Flatten the tree
        const flatTree = allParentItems.flat();
        
        const megaMenuChildrenContainer = flatTree.find(item => item.id === megaMenuId).childrenContainer;

        if ( !megaMenuChildrenContainer ) {
            return;
        }

        // Show the children container
        showElement(megaMenuChildrenContainer);
        target.classList.add('is-active');

        // Find parent with megaMenuId
        const parentContainer = this._tree.find(item => item.parentItems.some(parentItem => parentItem.id === megaMenuId));

        // Hide the other children containers in the same container
        let otherParentItems = parentContainer.parentItems;
        otherParentItems = otherParentItems.flat();

        otherParentItems.forEach(item => {
          if ( item.element !== target ) {
            hideElement(item.childrenContainer);
            item.element.classList.remove('is-active'); 
          }
        });

        // Set the current id
        this._currentId = megaMenuId;
    }
  }

  /**
   * Sliders
   * @type {Object}
   */
  const sliders = {
    init: function() {
      this.initBestSellersSlider();
    },
    initBestSellersSlider: function() {
      tns({
        container: '.essenza-header__navigation-best-sellers-list',
        items: 1.25,
        slideBy: 'page',
        autoplay: false,
        edgePadding: 24,
        gutter: 20,
        loop: false,
        controls: false,
        nav: false,
        autoplayButtonOutput: false,
        autoplayHoverPause: true,
        lazyload: true,
      });
    }
  }

  /**
   * Product Slider
   * @type {Object}
   */
  const productSlider = {
    _mainSlider: null,
    _navSlider: null,
    _currentIndex: 0,
    init: function() {
      this.initProductSlider();
    },
    initProductSlider: function() {
      const container = document.querySelector('.essenza-product-slider-content-container');

      if ( !container ) {
        return;
      }

      this._navSlider = tns({
        container: '.essenza-product-slider-nav-container',
        axis: 'vertical',
        items: 3,
        gutter: 10,
        autoplay: false,
        autoplayButtonOutput: false,
        autoplayHoverPause: true,
        prevButton: '.essenza-product-slider-nav-control-prev',
        nextButton: '.essenza-product-slider-nav-control-next',
        nav: false,
        mouseDrag: true,
        touch: true,
        loop: false,
        responsive: {
          1024: {
            items: 6,
          },
        },
      });

      this._mainSlider = tns({
        container: '.essenza-product-slider-content-container',
        items: 1,
        controls: false,
        mode: 'gallery',
        nav: false,
        mouseDrag: true,
        touch: true,
        loop: false,
        lazyload: true,
      });

      // Add the active class to the first nav item
      const firstNavItem = document.querySelector('.essenza-product-slider-img--thumb[data-index="0"]');
      firstNavItem.classList.add('is-active');

      // this._navSlider.events.on('indexChanged', this.onNavSliderIndexChanged.bind(this));
      document.querySelectorAll('.essenza-product-slider-img--thumb').forEach(item => {
        item.addEventListener('click', this.onNavSliderNavClick.bind(this));
      });
    },
    setActiveNavItem: function(index) {
      // Remove Class from the other nav items
      const otherNavItems = document.querySelectorAll('.essenza-product-slider-img--thumb:not([data-index="' + this._currentIndex + '"]');
      otherNavItems.forEach(item => {
        item.classList.remove('is-active');
      });

      // Add Class to the current nav item
      const currentNavItem = document.querySelector('.essenza-product-slider-img--thumb[data-index="' + index + '"]');
      currentNavItem.classList.add('is-active');
    },
    onNavSliderIndexChanged: function(event) {
      this._currentIndex = event.index;
      this._mainSlider.goTo(this._currentIndex);

      this.setActiveNavItem(this._currentIndex);
    },
    onNavSliderNavClick: function(event) {
      event.preventDefault();
      const target = event.currentTarget;
      const index = target.dataset.index;
      this._currentIndex = index;
      this._mainSlider.goTo(index);
      this.setActiveNavItem(index);
    }
  }

  /**
   * Product Variations
   * @type {Object}
   */
  const productVariations = {
    _variations: [],
    init: function() {
      this.initProductVariations();
      this.bindEvents();
    },
    initProductVariations: function() {
      let variations = document.querySelectorAll('.essenza-variation-picker-skin');
      
      variations.forEach(variation => {

        this._variations.push({
          attribute: variation.dataset.attribute,
          options: variation.querySelectorAll('.essenza-variation-picker-skin__option'),
          originalDropdown: document.querySelector('select#' + variation.dataset.attribute),
        });
      });
      
    },
    bindEvents: function() {
      this._variations.forEach(variation => {
        variation.options.forEach(option => {
          option.addEventListener('click', this.onVariationClick.bind(this));
        });
      });
    },
    onVariationClick: function(event) {
      event.preventDefault();
      const target = event.currentTarget;
      const value = target.dataset.value;
      
      const variation = this._variations.find(variation => variation.attribute === target.dataset.attribute);
      
      variation.originalDropdown.value = value;
      variation.originalDropdown.dispatchEvent(new Event('change'));
    }
  }

  /**
   * Product Promo
   * @type {Object}
   */
  const productPromo = {
    init: function() {
      this.initProductPromo();
    },
    initProductPromo: function() {
      const promoToggle = document.querySelector('.essenza-product-promo__toggle input[type="checkbox"]');
     
      if ( !promoToggle ) {
        return;
      }

      promoToggle.addEventListener('change', this.onPromoToggleChange.bind(this));
    },
    onPromoToggleChange: function(event) {
      event.preventDefault();

      const hiddenField = document.querySelector('#essenza-product-promo-toggle');

      if ( !hiddenField ) {
        return;
      }

      const promoToggle = event.currentTarget;
      hiddenField.value = promoToggle.checked ? '1' : '0';
    }
  }
  /**
   * Tabs
   * @type {Object}
   */
  const tabs = {
    init: function() {
      this.initTabs();
    },
    initTabs: function() {
      const tabs = document.querySelectorAll('.essenza-tabs__header-item a');
      tabs.forEach(tab => {
        tab.addEventListener('click', this.onTabClick.bind(this));
      });
    },
    onTabClick: function(event) {
      event.preventDefault();
      const target = event.target;
      const tabId = target.href.split('#')[1];
      const tabContent = document.getElementById(tabId);
      tabContent.classList.add('essenza-tabs__content-item--active');

      // Hide the other tab contents
      const otherTabContents = document.querySelectorAll('.essenza-tabs__content-item:not(#' + tabId + ')');
      otherTabContents.forEach(tabContent => {
        tabContent.classList.remove('essenza-tabs__content-item--active');
      });

      // Remove the active class from the other tabs
      const otherTabs = document.querySelectorAll('.essenza-tabs__header-item--active');
      otherTabs.forEach(tab => {
        tab.classList.remove('essenza-tabs__header-item--active');
      });

      // Set the active tab
      target.parentElement.classList.add('essenza-tabs__header-item--active');
    }
  }
  
  megaMenu.init();
  sliders.init();
  tabs.init();
  productSlider.init();
  productVariations.init();
  productPromo.init();
  videoPlayers.init();
})();
